// extracted by mini-css-extract-plugin
export default {"container":"hoardValues_container__Ij-6T"};